import { DividerProps, DividerComp } from "./types";

const Divider: DividerComp = (props: DividerProps) => {
  return (
    <div className="h-12 relative after:absolute after:top-1/2 after:-translate-y-1/2 after:h-[0.5px] after:left-0 after:right-0 after:bg-[#EAECF0]" />
  );
};

export default Divider;
